import { IAppConfig } from './app.config.base';

const apiRootUrl = 'https://admin-api.staq.com/api';
const client_Id = "600422881376-0vp107g56c3d907jdcgfnjf0eh7s056n.apps.googleusercontent.com";
const Client_secret = "aq-ehY21TxLjAvLsPTy0COo0";
const impersonation_url = "https://sso.app.staq.com/admin?identifier=";
const resetPasswordUrl = 'https://sso.app.staq.com'

export const ProductionConfig: IAppConfig = {
    apiEndpoint: apiRootUrl,
    phoneMask: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
    ClientId: client_Id,
    ClientSecret: Client_secret,
    GranType: "authorization_code",
    Redirect_Uri: window.location.origin + "/login-callback",
    AuthUrl: "https://accounts.google.com/o/oauth2/auth?",
    ResponseType: "code",
    Scope: "openid email profile",
    AccessType: "offline",
    TokenAPI: "https://accounts.google.com/o/oauth2/token",
    DeleteConnectionUrl: "/job_manager/connections/",
    DeleteCustomConnectionUrl: "/job_manager/custom_connections/",
    ConnectionVerificationUrl: "/job_manager/connection_verifications",
    DeleteApplicationsUrl: "v1/applications/",
    CollectionMissionUrl: "/job_manager/user_defined_collection_missions",
    ImpersonationUrl: impersonation_url,
    CustomConnectionFileUrl: "https://www.filepicker.io/api/file/",
    UserInfoKey: 'ui',
    TokenKey: 'tk',
    CryptoKey: 'w9y$B&E)H@McQfTjWnZr4u7x!A%C*F-J',
    RefreshTokenKey: "rtk",
    RefreshTokenExpiry: 0.5,
    RefreshTokenGrantType: 'refresh_token',
    FileStackUrl: "https://www.filestackapi.com/api/file/",
    FileStackKey: "A2sUouA4TlertEOzrgZDhz",
    FilePickerUrl: "https://www.filepicker.io/api/file/",
    PapertrailUrl: "https://papertrailapp.com/groups/1285144/events?q=",
    AdminStagingUrl: "https://admin-staging.gke.staq-infra.com/tps/connections/",
    GrafanaUrl: 'https://grafana.monitoring.gke.staq-infra.com/grafana/d/loki-logs/pod-logs?from=now-7d&to=now&viewPanel=panel-3&refresh=1m&orgId=1&timezone=browser&var-pod=$__all&var-search=$__all',
    resetPasswordUrl: resetPasswordUrl
};